import { getCodeInfoFromDomain, isIntl } from '@/utils';
import { getEnv } from './getEnv';

const apiHosts = {
  local: 'https://es-hotel-web-test.wywk.cn',
  // local: 'https://es-hotel-web-dev.wywk.cn',
  dev: 'https://es-hotel-web-dev.wywk.cn',
  test: 'https://es-hotel-web-test.wywk.cn',
  uat: 'https://es-hotel-web-uat.wywk.cn',
  prod: 'https://pms-web.wy-hotel.cn',
};

// 海外SaaS后端api域名
const intlApiHosts = {
  local: 'https://es-hotel-web-dev.sg.wanyoo.com',
  dev: 'https://es-hotel-web-dev.sg.wanyoo.com',
  test: 'https://es-hotel-web-test.sg.wanyoo.com',
  uat: 'https://es-hotel-web-uat.sg.wanyoo.com',
  prod: 'https://es-hotel-web.sg.wanyoo.com',
};

// 房价牌域名
const PriceBrandDomain = {
  local: 'http://localhost:3002',
  dev: 'https://price-brand-dev.wywk.cn',
  test: 'https://price-brand-test.wywk.cn',
  uat: 'https://price-brand-uat.wywk.cn',
  prod: 'https://price-brand.wywk.cn',
};

// 数据看板域名
const DashboardDomain = {
  // TODO local dev
  local: 'http://localhost:3001',
  dev: 'https://pms-data-dashbord-dev.wywk.cn',
  test: 'https://pms-data-dashbord-test.wywk.cn',
  uat: 'https://pms-data-dashbord-uat.wywk.cn',
  prod: 'https://pms-data-dashbord.wywk.cn',
};

// 鱼管家域名
const YGJDomain = {
  local: 'http://localhost:4000',
  dev: 'https://hwap-dev.wywk.cn',
  test: 'https://hwap-test.wywk.cn',
  uat: 'https://hwap-uat.wywk.cn',
  prod: 'https://hwap.wy-hotel.cn',
};

// 海外SaaS数据看板域名
const i18nDashboardDomain = {
  // TODO local dev
  local: 'http://localhost:3001',
  dev: 'https://pms-data-dashbord-dev.sg003.wanyoo.com',
  test: 'https://pms-data-dashbord-test.sg003.wanyoo.com',
  uat: 'https://pms-data-dashbord-uat.sg003.wanyoo.com',
  prod: 'https://pms-data-dashbord.sg000.wanyoo.com',
};

// Steam
const SteamDomain = {
  local: 'http://localhost:4000',
  dev: 'https://steam-dev.wywk.cn',
  test: 'https://steam-test.wywk.cn',
  uat: 'https://steam-uat.wywk.cn',
  prod: 'https://steam.wywk.cn',
};
// 海外Steam
const i18nSteamDomain = {
  local: 'http://localhost:4000',
  dev: 'https://steam-dev.sg003.wanyoo.com',
  test: 'https://steam-test.sg003.wanyoo.com',
  uat: 'https://steam-uat.sg003.wanyoo.com',
  prod: 'https://steam.sg000.wanyoo.com',
};

// 排班域名
const ScheduleDomain = {
  // TODO local dev
  local: 'http://localhost:3001',
  dev: 'http://localhost:3001',
  test: 'https://scheduling-management-test.wywk.cn',
  uat: 'https://scheduling-management-uat.wywk.cn',
  prod: 'https://scheduling-management.wywk.cn',
};

// 房价牌域名获取
const getPriceBrandHost = () => {
  return PriceBrandDomain[getEnv()];
};

const getSteamHost = () => {
  const env = getEnv();
  const { apiThirdLevel } = getCodeInfoFromDomain();
  const isIntlFlag = isIntl();
  return isIntlFlag ? i18nSteamDomain[env].replace('.sg.', `.${apiThirdLevel}.`) : SteamDomain[env];
};

// 看板域名获取
const getDashboardHost = () => {
  const env = getEnv();
  const { apiThirdLevel } = getCodeInfoFromDomain();
  const isIntlFlag = isIntl();
  return isIntlFlag
    ? i18nDashboardDomain[env].replace('.sg.', `.${apiThirdLevel}.`)
    : DashboardDomain[env];
  // return DashboardDomain[getEnv()];
};

// 排班域名获取
const getSheduleHost = () => {
  return ScheduleDomain[getEnv()];
};

// 鱼管家域名获取
const getYGJHost = () => {
  return YGJDomain[getEnv()];
};

// cdn域名地址动态获取
const getCdnHost = () => {
  const isIntlFlag = isIntl();
  if (window.location.hostname.includes('localhost')) return '//static.wywk.cn'; // local
  if (!isIntlFlag) return '//static.wywk.cn'; // 国内
  // 获取国家标识
  const { apiThirdLevel } = getCodeInfoFromDomain();
  return `//static-${apiThirdLevel}.wanyoo.com`; // 国外
};

export {
  apiHosts,
  intlApiHosts,
  getPriceBrandHost,
  getSteamHost,
  getDashboardHost,
  getSheduleHost,
  getCdnHost,
  getYGJHost,
};
